export default __webpack_public_path__ + "static/media/activity-1.a183f7d6.png";